<template>
  <v-app-bar
    color="header"
    class="work-header-bar"
    dark
    flat
  >
    <div
      class="work-logo"
    >
      <slot name="logo" />
    </div>

    <div class="work-app-vertical-spacer" />

    <slot name="prepend-actions" />

    <slot name="search-action" />

    <v-spacer />

    <v-toolbar-title
      class="active-module-name"
      ref="activeModuleName"
    >
      <slot 
        name="title" 
        v-if="activeModuleHasName"
      >        
        <h1 
          v-if="getName && getName !== ''"
          ref="moduleTitle"          
        >
          {{ truncate(getName, 40) }}
        </h1>
        <h4 
          v-if="getSubtitle" 
          style="color:var(--v-work_card-base)" 
        >
          {{ getSubtitle }}
        </h4>
      </slot>
    </v-toolbar-title>

    <v-spacer v-if="activeModuleHasName" />

    <slot name="user-information" />

    <div class="work-app-vertical-spacer" />

    <slot name="append-actions" />
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';
import { truncate } from '@/services/truncate-service';

export default {
  name: 'WorkBaseHeaderBar',
  mounted() {
    this.$nextTick(() => this.initHeaderObserver())
  },
  beforeUnmount() {
    if (this.ro) this.ro.disconnect()
  },
  computed: {
    ...mapGetters(['getName', 'getSubtitle']),
    activeModuleHasName() {
      return (
        (this.getName != undefined && this.getName !== '') || this.getSubtitle != undefined
      );
    },
  },
  methods: {
    truncate,
    initHeaderObserver() {
      const container = this.$refs.activeModuleName;
      if (!container) return;
      if (!this.ro) {
        this.ro = new ResizeObserver(() => {
          requestAnimationFrame(() => this.fitHeaderTitle());
        });
        this.ro.observe(container);
      }

      this.fitHeaderTitle();
    },
    fitHeaderTitle() {
      const h1 = this.$refs.moduleTitle;
      const container = this.$refs.activeModuleName;
      if (!h1 || !container) return;

      cancelAnimationFrame(this.fitRAF);
      this.fitRAF = requestAnimationFrame(() => {

        const parentWidth = container.clientWidth;
        let fontSize = 32;
        h1.style.fontSize = fontSize + 'px';
        h1.style.whiteSpace = 'nowrap';

        while (h1.scrollWidth > parentWidth && fontSize > 16) { 
          fontSize -= 1;
          h1.style.fontSize = fontSize + 'px';
        } 
      });
    }
  },
};
</script>

<style lang="scss">
.work-header-bar {
  @import '../../styles/app/reusable-styling';

  height: $header-size !important;

  &::v-deep.v-toolbar {
    border-bottom: 0.13rem solid $header-border-color !important;
  }
  .v-toolbar__content {
    height: $header-size !important;
  }

  .work-app-vertical-spacer {
    border-left: 0.063rem solid rgb(167, 184, 221);
    height: 2.5rem;
    margin-right: 0.625rem;
    margin-left: 1.563rem;
  }

  .active-module-name {
    display: flex;
    width: 100%;
    justify-content: center;
    > h1 {
      width: fit-content;
      padding: 0 1rem !important;
    }
  }

  .work-logo {
    cursor: pointer;
  }
}
</style>
